<div class="igo-input-container">
  <mat-form-field>
    <textarea
      #textArea
      matInput
      readonly
      rows="3"
      [placeholder]="'igo.context.shareMap.placeholderLink' | translate"
      [value]="url"
    ></textarea>
  </mat-form-field>

  <div class="igo-share-map-url-content">
    <div class="igo-form-button-group">
      <button matButton="elevated" (click)="copyTextToClipboard(textArea)">
        <mat-icon>content_copy</mat-icon>
        {{ 'igo.context.shareMap.copy' | translate }}
      </button>
    </div>

    <div>
      <br />
      <section>
        @if (('igo.context.shareMap.htmlClarifications' | translate) === '') {
          <div>
            @if (('igo.context.shareMap.included' | translate) !== '') {
              <h4>
                {{ 'igo.context.shareMap.included' | translate }}
              </h4>
            }
            <ul>
              @if (('igo.context.shareMap.context' | translate) !== '') {
                <li>
                  {{ 'igo.context.shareMap.context' | translate }}
                </li>
              }
              @if (('igo.context.shareMap.center' | translate) !== '') {
                <li>
                  {{ 'igo.context.shareMap.center' | translate }}
                </li>
              }
              @if (('igo.context.shareMap.zoom' | translate) !== '') {
                <li>
                  {{ 'igo.context.shareMap.zoom' | translate }}
                </li>
              }
              @if (('igo.context.shareMap.addedLayers' | translate) !== '') {
                <li>
                  {{ 'igo.context.shareMap.addedLayers' | translate }}
                </li>
              }
              @if (
                ('igo.context.shareMap.visibleInvisible' | translate) !== ''
              ) {
                <li>
                  {{ 'igo.context.shareMap.visibleInvisible' | translate }}
                </li>
              }
            </ul>
            @if (('igo.context.shareMap.excluded' | translate) !== '') {
              <h4>
                {{ 'igo.context.shareMap.excluded' | translate }}
              </h4>
            }
            <ul>
              @if (('igo.context.shareMap.order' | translate) !== '') {
                <li>
                  {{ 'igo.context.shareMap.order' | translate }}
                </li>
              }
              @if (('igo.context.shareMap.opacity' | translate) !== '') {
                <li>
                  {{ 'igo.context.shareMap.opacity' | translate }}
                </li>
              }
              @if (('igo.context.shareMap.filterOgc' | translate) !== '') {
                <li>
                  {{ 'igo.context.shareMap.filterOgc' | translate }}
                </li>
              }
              @if (('igo.context.shareMap.filterTime' | translate) !== '') {
                <li>
                  {{ 'igo.context.shareMap.filterTime' | translate }}
                </li>
              }
            </ul>
          </div>
        }
        @if (('igo.context.shareMap.htmlClarifications' | translate) !== '') {
          <igo-custom-html
            class="shareCustomPadding"
            [html]="'igo.context.shareMap.htmlClarifications' | translate"
          />
        }
      </section>
    </div>
  </div>
</div>
